import type React from 'react'
import './styles.scss'

interface CardReliabilityProps {
  title: string
  children: React.ReactNode
  collectDate: string
}
function DataSourceCard({
  title,
  children,
  collectDate,
}: CardReliabilityProps) {
  return (
    <div className="container-cardUnic">
      <header className="container-cardUnic__header">
        <h3 className="container-cardUnic__title">{title}</h3>
        {collectDate?.length > 0 ? (
          <time
            className="container-cardUnic__updateTime"
            dateTime={collectDate}
          >
            Última atualização: {collectDate}
          </time>
        ) : (
          <div className="container-cardUnic__updateTime">
            Data de atualização indisponível
          </div>
        )}
      </header>
      <div className="container-cardUnic__inner">{children}</div>
    </div>
  )
}

export default DataSourceCard
